module.exports = __webpack_public_path__ + "img/5.95bac327.png";